import { useMemo } from 'react';
import { CarrierReferenceItem, getCarriersFromMerchantRules } from 'features/authorization/helpers/carrierReference';
import {
	MERCHANT_RULES_WAIT_MS,
	MerchantRulesSource,
	merchantRulesSource,
	useMerchantRulesRead,
} from 'features/authorization/merchantRules/useMerchantRules';
import { carriersOf } from '../helpers/merchantReference';

/** Cuánto se espera a `/rules` antes de mostrar la tabla fija, que se reemplaza cuando llegan. */
export const MERCHANT_REFERENCE_WAIT_MS = MERCHANT_RULES_WAIT_MS;

/** De dónde salen las reglas que se ven (`MerchantRulesSource`). */
export type MerchantReferenceSource = MerchantRulesSource;

const NONE: CarrierReferenceItem[] = [];

/**
 * Las aerolíneas de "Códigos de comercio y cuotas": las reglas vigentes de la agencia 1 (`GET /rules`, con el mismo
 * pedido y lo guardado que el modal de autorización, `useMerchantRules`) o, si la Support API no las da, la tabla fija
 * del Power (`MERCHANT_NUMBER_RULES`). Si las de la base llegan después de los 5 s, reemplazan a la tabla fija.
 */
export function useMerchantReference(): {
	carriers: CarrierReferenceItem[];
	source: MerchantReferenceSource;
	/** La tabla fija, para cuando las de la base se rompen al dibujarse. */
	fixed: CarrierReferenceItem[];
} {
	const { read, slow } = useMerchantRulesRead(true);
	const fixed = useMemo(getCarriersFromMerchantRules, []);
	const base = useMemo(() => (read?.rules?.length ? carriersOf(read.rules) : null), [read]);
	const source = merchantRulesSource(read, slow);

	if (source === 'loading') return { carriers: NONE, source, fixed };
	return { carriers: base ?? fixed, source, fixed };
}
